/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F2_TitleInputs */

const en_landing_features_f2_title = /** @type {(inputs: Landing_Features_F2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type that survives the edit`)
};

const zh_landing_features_f2_title = /** @type {(inputs: Landing_Features_F2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改完文字依然工整`)
};

/**
* | output |
* | --- |
* | "Type that survives the edit" |
*
* @param {Landing_Features_F2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f2_title = /** @type {((inputs?: Landing_Features_F2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f2_title(inputs)
	return zh_landing_features_f2_title(inputs)
});
export { landing_features_f2_title as "landing.features.f2_title" }